module.exports = __webpack_public_path__ + "media/recipes/153-e77ecb75.png";